import React from "react";
import VoucherList from "./VoucherList";
import { FiXCircle } from "react-icons/fi";

const InactiveVouchers = () => {
  return (
    <VoucherList
      title="Expired Vouchers"
      filterStatus="inactive" // Normalized status for expired vouchers
      icon={<FiXCircle color="#d32f2f" size={22} />}
    />
  );
};

export default InactiveVouchers;
